module.exports = __webpack_public_path__ + "static/media/icons_Torticolis cong‚nital et plagioc‚phalie.357eee6c.svg";